import { Component, OnDestroy, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subscription, forkJoin } from "rxjs";
import { BOClinicHistory } from "../../models/BOClinicHistory.model";
import { BOFilter } from "../../models/BOFilter";
import { ClinicHistoryService } from "../../services/clinicHistory.service";
import { ClinicHistoriesPatientComponent } from "../clinicHistoriesPatient.component";
import { CreateOrEditClinicHistoryComponent } from "./createOrEditClinicHistory.component";
//Ric
import { Router } from "@angular/router";
import { ServiceTypeService } from '../../services/service-type.service';
import { BOItem } from "../../models/BOItem.model";
import { MatSelectChange } from "@angular/material/select";
import { MatDialog } from "@angular/material/dialog";
import { InvoicesComponent } from "../invoices/invoices.component";
import { InvoicesTaskComponent } from "../invoices-task/invoices-task.component";
import { ServiceGroupsService } from "../../services/serviceGroups.service";
import { animate, state, style, transition, trigger } from "@angular/animations";

//Ric end
@Component({
    templateUrl: './clinicHistory.component.html',
    styleUrls: ['./clinicHistory.component.css'],
    animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', overflow: 'hidden' })),
      state('expanded', style({ height: '*', overflow: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})
export class ClinicHistoryComponent implements OnDestroy{
    @ViewChild('createOrEditClinicHistoryModal', {static:true}) createOrEditClinicHistoryModal: CreateOrEditClinicHistoryComponent;
    @ViewChild('clinicHistoriesPatientModal', { static: true }) clinicHistoriesPatientModal: ClinicHistoriesPatientComponent;
    @ViewChild('invoicesModal', {static:true}) invoicesModal: InvoicesComponent;
    @ViewChild('invoicesTask', {static:true}) invoicesTask: InvoicesTaskComponent;



    clinicHistoryList: BOClinicHistory[];
    clinicHistoryListShort: BOClinicHistory[];

    busy:Subscription;
    clinicHistoryFilter:string = "";
    data=true;
    selectedArea=0;
    areaSelected=1;
    selectedGroup:number=0;

    showCreateClinicHistory:boolean=false;
    showSearchPatient:boolean=false;
    serviceTypeList: BOItem[] = [];
    groupServiceList: BOItem[] = [];

    filterRangesDates={
      startDate:null,
      endDate:null
    }

        //new

     dataSource: any[] = [
    { name: 'OPCIONES PARA AUXILIAR', type: 'history' },
    { name: 'OPCIONES PARA MÉDICO', type: 'doctor' }
  ];
//     displayedColumns = ['expand', 'title'];
     displayedColumns = ['title', 'expand'];

     expandedElement: any | null;

    constructor(public toastr: ToastrService,
                private _clinicHistoryService:ClinicHistoryService,
                private _serviceTypeService:ServiceTypeService,
                private _groupService: ServiceGroupsService,
               ) { }



    ngOnInit(): void
    {
      console.log("Entra a NGONINIT CH");
       const filterInput: BOFilter = {filter: this.clinicHistoryFilter}
       this.busy=forkJoin
       (
          {
            resultClinicHistory:this._clinicHistoryService.getClinicHistories(filterInput,1),
            resultServiceTypeService:this._serviceTypeService.getAll(),
            resultGroupService: this._groupService.getAll(),


          }
       ).subscribe
        (({resultClinicHistory, resultServiceTypeService,resultGroupService})=>
          {
            this.clinicHistoryList=resultClinicHistory;
            this.serviceTypeList=resultServiceTypeService;
            this.groupServiceList=resultGroupService.filter(x=>x.areaId==1);

          if(this.clinicHistoryList.length>0)
          {

                for(let i=0; i<this.clinicHistoryList.length; i++)
                {
                  let serviceType=this.clinicHistoryList[i].serviceType;
                  this.clinicHistoryList[i].serviceTypeName= this.serviceTypeList.find(x=>x.code==serviceType)?.name;
                }

                this.filterClinicHistoriesByArea()
            }
            else
            {
              this.toastr.warning("Sin data", "No hay registros",{
              timeOut: 1500} );
            }


            this.clinicHistoryListShort=this.clinicHistoryList;

          }
        ) //end subscribe ForkJoin

      }

    // getAllClinicHistories()
    // {
    //     this.clinicHistoryList=[];
    //     const filterInput: BOFilter = {
    //         filter: this.clinicHistoryFilter.toUpperCase().trim()
    //     }
    //     this.busy = this._clinicHistoryService.getClinicHistories(filterInput, 1)
    //     .subscribe(data=>{this.clinicHistoryList = data;
    //          //Ric
    //         if(!data.length) this.clinicHistoryFilter= "";

    //         if(this.clinicHistoryList.length>0){

    //           for(let i=0; i<this.clinicHistoryList.length; i++)
    //           {
    //             let serviceType=this.clinicHistoryList[i].serviceType;
    //             this.clinicHistoryList[i].serviceTypeName= this.serviceTypeList.find(x=>x.code==serviceType)?.name;
    //           }
    //           this.clinicHistoryListShort=[...this.clinicHistoryList];
    //         }

    //     });

    // }

    getAllClinicHistories(optionToClose:string)
    {
        this.clinicHistoryList=[];
        const filterInput: BOFilter = {
            filter: this.clinicHistoryFilter.toUpperCase().trim()
        }
        this.busy = this._clinicHistoryService.getClinicHistories(filterInput, 1)
        .subscribe(data=>{this.clinicHistoryList = data;
             //Ric
            if(!data.length) this.clinicHistoryFilter= "";

            if(this.clinicHistoryList.length>0)
            {

              for(let i=0; i<this.clinicHistoryList.length; i++)
              {
                let serviceType=this.clinicHistoryList[i].serviceType;
                this.clinicHistoryList[i].serviceTypeName= this.serviceTypeList.find(x=>x.code==serviceType)?.name;
              }
              this.clinicHistoryListShort=[...this.clinicHistoryList];
              this.closeOpcionesAuxiliar(optionToClose);

            }

        });

    }


    navigateToClinicHistory(optionToClose:string): void
    {
      this.clinicHistoryList=[];
      this.clinicHistoryListShort=[];

      const filterInput: BOFilter = {
        filter: ""
      }

      this.busy=this._clinicHistoryService.getClinicHistories(filterInput,1).subscribe((data)=>{
        this.clinicHistoryList=data;

        if(!data.length) this.clinicHistoryFilter= "";

        if(this.clinicHistoryList.length>0)
        {

          for(let i=0; i<this.clinicHistoryList.length; i++)
          {
            let serviceType=this.clinicHistoryList[i].serviceType;
            this.clinicHistoryList[i].serviceTypeName= this.serviceTypeList.find(x=>x.code==serviceType)?.name;
          }
          this.clinicHistoryListShort=[...this.clinicHistoryList];
          this.closeOpcionesAuxiliar(optionToClose);
        }

      });

    }

    onAreaSelectionChange(event: MatSelectChange): void
    {
      const selectedValue = event.value;
      this.selectedArea=selectedValue;
      this.clinicHistoryListShort=[];

      if(this.selectedArea==3)
      {
        this.clinicHistoryListShort=[...this.clinicHistoryList];
      }
      else
      {
        let clinicHistoriesFiltered=this.clinicHistoryList.filter(x=>x.area==this.selectedArea);
        this.clinicHistoryListShort=[...clinicHistoriesFiltered];
      }


    }

   onGroupSelectionChange(event: MatSelectChange): void {
        this.selectedGroup = event.value;
        this.filterClinicHistoriesByGroup();
  }
    private filterClinicHistoriesByArea(): void {
        if (this.selectedArea === 3 || this.selectedArea === 0) {
            // Show all records
            this.clinicHistoryListShort = [...this.clinicHistoryList];

        } else {
            // Filter by selected area
            this.clinicHistoryListShort = this.clinicHistoryList
                .filter(x => x.area === this.selectedArea);
        }


    }

    private filterClinicHistoriesByGroup(): void {
      let selectedGroupString="";

      if(this.selectedGroup<10)
      {
        selectedGroupString="0"+this.selectedGroup.toString().trim();
      }
      else
      {
        selectedGroupString=this.selectedGroup.toString().trim();

      }
      this.clinicHistoryListShort = this.clinicHistoryList
                .filter(x => x.serviceGroups == selectedGroupString);

        if(this.clinicHistoryListShort.length<=0)
        {
          this.toastr.warning("Sin data", "No hay registros", {
          timeOut: 1500 });
        }
    }

    openCreateOrEditChGo3(clinicHistoryId:number)
    {

      return new Promise<void>((resolve, reject) => {
        try
        {
          // Ejecutar el método openModal
          this.createOrEditClinicHistoryModal.openModal(clinicHistoryId, false, 'edi', false);

          // Asegurarse de resolver después de que el openModal termine
          resolve();
        } catch (error) {
          // Si ocurre algún error, rechaza la promesa
          reject(error);
        }
      }).then(() => {
        // Llamar al método openCreateReport después de que openModal haya finalizado
        this.createOrEditClinicHistoryModal.openCreateReport(clinicHistoryId);
      }).catch((error) => {
        console.error('Error al ejecutar las acciones:', error);
      });
    }

    openDiagnosticInClinicHistory(clinicHistoryId:number)
        {

              return new Promise<void>((resolve, reject) => {
                      try {
                                // Ejecutar el método openModal
                                          this.createOrEditClinicHistoryModal.openModal(clinicHistoryId, false, 'edi',false);

                                                    // Asegurarse de resolver después de que el openModal termine
                                                              resolve();
                                                                      } catch (error) {
                                                                                // Si ocurre algún error, rechaza la promesa
                                                                                          reject(error);
                                                                                                  }
                                                                                                        }).then(() => {
                                                                                                                // Ir a la pantalla Diagnosticos
                                                                                                                        this.createOrEditClinicHistoryModal.goToDiagnostic(clinicHistoryId);
                                                                                                                              }).catch((error) => {
                                                                                                                                      console.error('Error al ejecutar las acciones:', error);
                                                                                                                                            });
                                                                                                                                                }


getClinicalHistoriesByAllAndDates()
{

    this._clinicHistoryService.getCHWithPatientByDatesAndArea(this.filterRangesDates, 1)
        .subscribe({
          next:(data:BOClinicHistory[])=>{
            this.clinicHistoryListShort=[];

            if(data.length>0){
               this.clinicHistoryList=data;
               this.clinicHistoryListShort=data;

                        // Assign service type names
                this.clinicHistoryListShort.forEach(history => {
                  history.serviceTypeName = this.serviceTypeList.find(x =>
                    x.code === history.serviceType)?.name;
                });

                this.selectedGroup=0;
            }
            else{
              this.toastr.warning("Sin data", "No hay registros", {
              timeOut: 1500 });
            }


          },
          error:(err)=>{
                    console.log("Error al obtener Historias Clínicas");
          },
          complete:()=>{
            console.log("Servicio completado");
          }

        });//end subscribe
}

 toggleExpansion(element: any): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

closeOpcionesAuxiliar(optionChoosed:string): void {
    //const elementToClose = this.dataSource.find(el => el.name === 'OPCIONES PARA AUXILIAR');
    const elementToClose = this.dataSource.find(el => el.name === optionChoosed);

    if (elementToClose && this.expandedElement === elementToClose) {
      this.toggleExpansion(elementToClose);  // Esto la colapsará (expandedElement = null)
    }
  }








  ngOnDestroy(): void {
      this.busy?.unsubscribe();
  }
}
